import useSdkLogin from '../hooks/useSdkLogin';
var events = {
  'question:miniapp:open:float:modal': [useSdkLogin]
};
export default events;